import { render, staticRenderFns } from "./Documentacao.vue?vue&type=template&id=92e2dcda"
import script from "./Documentacao.vue?vue&type=script&lang=js"
export * from "./Documentacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports